import { Upload, Camera } from 'lucide-react';
import { motion } from 'framer-motion';

export function CaptureMode({ mode, setMode }) {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex gap-2"
    >
      <button
        onClick={() => setMode('upload')}
        className={`flex-1 py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors ${
          mode === 'upload'
            ? 'bg-emerald-600 text-white'
            : 'bg-white text-gray-700 hover:bg-gray-100'
        }`}
      >
        <Upload className="w-5 h-5" />
        Upload
      </button>
      <button
        onClick={() => setMode('camera')}
        className={`flex-1 py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors ${
          mode === 'camera'
            ? 'bg-emerald-600 text-white'
            : 'bg-white text-gray-700 hover:bg-gray-100'
        }`}
      >
        <Camera className="w-5 h-5" />
        Camera
      </button>
    </motion.div>
  );
}